enum AfterCodeActions {
    login = 'login',
    register = 'register',
}

export { AfterCodeActions };
